<div class="to-top" (click)="scrollToTop()" [ngClass]="{ 'show-scrollTop': windowScrolled }">
  <img src="../assets/images/top_button.png" alt="to-top-icon" />
</div>